import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
 
import { _HttpClient } from '../../net/http.client';
import { ApiService } from '../../net/apiRoute';
import { NzFormatEmitEvent } from 'ng-zorro-antd/tree';

@Component({
  selector: 'app-select-menus',
  templateUrl: './app-select-menus.component.html',
  styleUrls: ['./app-select-menus.component.css'],
})

export class AppSelectMenusComponent implements OnInit {
  @Input() parentId: any; // 输入参数 父级ID
  @Input() nzCheckable;
  @Output() menuTree: EventEmitter<string> = new EventEmitter(); // 输出属性 菜单树
  nzShowSearch: false;
  nzCheckStrictly: false; // checkable 状态下节点选择完全受控（父子节点选中状态不再关联）
  nzPlaceHolder: '不选择 默认为一级菜单';
  nzDefaultExpandAll: true;
  nzDisabled:any;
  nodes: any = [];

  constructor(private http: _HttpClient) {}

  ngOnInit(): void {
    this.initSelectStatus();
    this.loadData();
  }

  initSelectStatus(){
    if(this.parentId!="" && this.parentId!= null){
      this.nzDisabled = true;
  }
  else{
    this.nzDisabled = false;
  }
}

  // 下拉项改变
  onChange(value): void {
    this.menuTree.emit(value);
  }

  nzEvent(event: NzFormatEmitEvent): void {
    console.log(event);
  }

  // 加载数据
  loadData() {
    this.http.get(ApiService.GetSelectMenuTree, {roleId:""}).subscribe((res: any) => {
      this.nodes = res.Result.nodes;
    });
  }
}
